import { useState } from 'react'
import classes from './ULTabsV2.module.scss'

interface ULTabsV2Props {
  components: any
  containerClassName: string
  contentClassName: string
  tabsCounter: any[] | null
  callBackUponTabChange?: (activeTab: number) => void
}

const ULTabsV2 = (props: ULTabsV2Props) => {
  const [tab, setTab] = useState(0)

  return (
    <div className={`ul-tabs__container ${props.containerClassName}`}>
      <div className="ul-tabs -boxed -medium">
        {props.components.map((component: any, index: number) => {
          if (component?.hidden) return <></>

          return (
            <div
              key={component.headerName}
              className={`ul-tabs__item ${tab === index ? '-active' : ''}`}
              onClick={() => {
                if (props.callBackUponTabChange) props.callBackUponTabChange(index)

                setTab(index)
              }}
            >
              {props.tabsCounter != null && props.tabsCounter.length > 0 ? (
                props.tabsCounter[index] > 0 ? (
                  <div className={`${classes['tabs-headerName']}`}>
                    {component.headerName}
                    <span className={`${classes['tabs-counter']}`}>{props.tabsCounter[index]}</span>
                  </div>
                ) : (
                  <span>{component.headerName}</span>
                )
              ) : (
                <span>{component.headerName}</span>
              )}
            </div>
          )
        })}
      </div>
      <div className={`ul-tabs__content ${props.contentClassName}`}>
        {props.components[tab].components}
      </div>
    </div>
  )
}

export default ULTabsV2
